// Cognito hosted-UI OAuth endpoints. The SPA client is public (PKCE, no secret).
import { config } from "../config";

const base = `https://${config.cognitoDomain}`;

export const AUTHORIZE = `${base}/oauth2/authorize`;
export const TOKEN = `${base}/oauth2/token`;
export const LOGOUT = `${base}/logout`;
export const SCOPES = "openid email profile";

export interface IdTokenClaims {
  sub: string;
  iss: string;
  aud: string;
  exp: number;
  iat: number;
  email?: string;
  name?: string;
  picture?: string;
  "cognito:username"?: string;
}

export interface TokenResponse {
  id_token: string;
  access_token: string;
  refresh_token?: string;
  expires_in: number;
}

export async function exchangeCode(code: string, verifier: string): Promise<TokenResponse> {
  const res = await fetch(TOKEN, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({
      grant_type: "authorization_code",
      client_id: config.cognitoClientId,
      code,
      redirect_uri: config.redirectUri,
      code_verifier: verifier,
    }),
  });
  if (!res.ok) throw new Error(`token exchange failed: ${res.status} ${await res.text()}`);
  return (await res.json()) as TokenResponse;
}
